import { all } from 'redux-saga/effects'

import { dataSaga } from './data/saga'
import { employerSaga } from './employer/sagas'

export function* editSaga() {
  yield all([dataSaga(), employerSaga()])
}
